import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import type { CartItemOrderCardProps } from './type'

import { ItemThumbnailBannar } from '@/components/features/item'
import { DeleteFilledIcon } from '@/components/icons/DeleteFilled'
import { Button, Icon, InputCheckbox, TextButton } from '@/components/ui'

import { ItemOrderCardPrice } from './ItemOrderCardPrice'
import { CartItemErrorLabel } from '../CartItemErrorLabel'

export const CartItemOrderCard = ({
  item,
  salesTypeQuantities,
  selectable = false,
  selected = false,
  disableEdit = false,
  disableDelete = false,
  isLoadingDelete = false,
  isVisiblePurchasePrice = false,
  onClickDetail = () => {},
  onClickEdit = () => {},
  onClickDelete = () => {},
  onSelect = () => {},
}: CartItemOrderCardProps) => {
  const { t } = useTranslation()

  return (
    <>
      <div
        className={clsx(
          'tw-px-2 tw-py-1',
          'tw-rounded tw-border tw-border-gray-300'
        )}
      >
        <div className={clsx('tw-w-full', 'tw-flex', 'tw-gap-2')}>
          {selectable && (
            <div
              className={clsx(
                'tw-flex-none',
                'tw-px-2',
                'tw-flex tw-items-center'
              )}
            >
              <InputCheckbox
                checked={!!selected}
                label={item.itemName}
                handleChange={onSelect}
              />
            </div>
          )}
          <div
            className={clsx(
              'tw-w-full',
              'tw-flex tw-flex-col',
              'lg:tw-flex-row lg:tw-justify-between',
              'tw-gap-2',
              'tw-py-1'
            )}
          >
            <div className={clsx('tw-w-full lg:tw-w-1/2')}>
              <ItemThumbnailBannar
                item={item}
                nameFooter={
                  <>
                    <CartItemErrorLabel status={item.itemStatus} />
                  </>
                }
              />
            </div>
            <div className={clsx('tw-flex', 'tw-flex-1', 'tw-gap-x-3')}>
              <div className={clsx('tw-flex-1')}>
                {item.itemStatus === 'available' && (
                  <ItemOrderCardPrice
                    item={item}
                    cartSalesTypeQuantities={
                      selectable ? undefined : salesTypeQuantities
                    }
                    direction={'vertical'}
                    showCount={!selectable}
                    showPurchasePrice={isVisiblePurchasePrice}
                  />
                )}

                {/** Note: 選択モードの時、各ボタンを見せない */}
                {!selectable && (
                  <>
                    <TextButton
                      variant={'alert'}
                      /**
                       * Note:
                       * 商品が利用不可の場合、いずれの場合も削除可能とする
                       * 利用可能な場合は全体の編集フラグによって出し分ける
                       */
                      disabled={disableDelete && item.itemStatus === 'available'}
                      onClick={onClickDelete}
                      isLoading={isLoadingDelete}
                    >
                      <Icon
                        icon={DeleteFilledIcon}
                        size={'lg'}
                        color={'alert'}
                      />
                      <p>{t('item.order.delete')}</p>
                    </TextButton>
                  </>
                )}
              </div>
              {/** Note: 選択モードもしくは商品が利用不可の場合、各ボタンを見せない */}
              {!selectable && (
                <div
                  className={clsx('tw-flex tw-flex-col', 'tw-gap-1', 'tw-w-20')}
                >
                  <Button
                    size={'sm'}
                    variant={'secondary'}
                    disabled={item.itemStatus !== 'available'}
                    onClick={onClickDetail}
                  >
                    {t('item.order.detail')}
                  </Button>
                  <Button
                    size={'sm'}
                    variant={'secondary'}
                    onClick={onClickEdit}
                    disabled={item.itemStatus !== 'available' || disableEdit}
                  >
                    {t('item.order.edit')}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
